import { Group } from '@optiro/ui';

import { useHeaderToolbarSlotStore } from '@/stores/headerToolbarSlotStore';

export const HeaderToolbarSlot = () => {
  const setElement = useHeaderToolbarSlotStore((state) => state.setElement);

  return <Group ref={setElement} gap="xs" wrap="nowrap" />;
};
